import { Box, Skeleton, Stack } from '@ethings/ui-toolkit';
import { FC } from 'react';

export const TripCardSkeleton: FC = () => (
  <Box
    style={{
      border: '1px solid rgba(0, 0, 0, 0.12)',
      borderRadius: 8,
      padding: 12,
    }}
  >
    <Stack direction="row" spacing={1.5}>
      <Skeleton height={32} variant="circular" width={32} />
      <Stack flex={1} spacing={1}>
        <Skeleton height={20} variant="text" width="38%" />
        <Skeleton height={18} variant="text" width="64%" />
        <Stack direction="row" flexWrap="wrap" gap={1}>
          <Skeleton height={28} variant="rounded" width={78} />
          <Skeleton height={28} variant="rounded" width={94} />
          <Skeleton height={28} variant="rounded" width={82} />
          <Skeleton height={28} variant="rounded" width={88} />
        </Stack>
      </Stack>
    </Stack>
  </Box>
);
